import { useNavigate } from "react-router-dom";
import { ROUTES as mobileRoutePaths } from "../router/mobile/routes";
import { routes as publicRoutes } from "../router/public/routes";

export const clearNavigationBlockers = () => {
  (window as any).navigationBlocker = null;
  (window as any).hasUnsavedChanges = false;
  (window as any).navigationBlockerPath = null;
};

export const useAppNavigate = () => {
  const navigate = useNavigate();

  return navigate;
};

export { useNavigate };

export type TMobileRouterPath =
  (typeof mobileRoutePaths)[keyof typeof mobileRoutePaths];

export type TWebRouterPath = TMobileRouterPath;

export type TPublicRouterPath =
  (typeof publicRoutes)[keyof typeof publicRoutes]["path"];
